var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F2E6F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_2100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.053 28.5063V27.5452C39.053 25.2447 38.239 23.1071 36.7631 21.521C35.2505 19.8929 33.1707 19 30.9018 19H30.1087C27.8398 19 25.76 19.8929 24.2474 21.521C22.7715 23.1071 21.9574 25.2447 21.9574 27.5452V28.5063C20.1665 28.6271 18.7432 30.1187 18.7432 31.9412V33.4433C18.7432 35.3393 20.2873 36.8834 22.1833 36.8834H24.1213C24.468 36.8834 24.7516 36.5998 24.7516 36.2532V29.1261C24.7516 28.7794 24.468 28.4958 24.1213 28.4958H23.218V27.5452C23.218 23.3908 26.1801 20.2605 30.1035 20.2605H30.8965C34.8251 20.2605 37.782 23.3908 37.782 27.5452V28.4958H36.8787C36.532 28.4958 36.2484 28.7794 36.2484 29.1261V36.2479C36.2484 36.5945 36.532 36.8782 36.8787 36.8782H37.761C37.5037 40.166 35.24 40.9275 34.1896 41.1008C33.9007 40.2132 33.0656 39.5725 32.0835 39.5725H30.5079C29.2894 39.5725 28.2967 40.5651 28.2967 41.7836C28.2967 43.0021 29.2894 44 30.5079 44H32.0887C33.1077 44 33.9637 43.3067 34.2211 42.3718C34.7358 42.2983 35.5499 42.1145 36.3587 41.6418C37.4984 40.9748 38.8482 39.6145 39.0268 36.8729C40.8282 36.7626 42.2568 35.2658 42.2568 33.438V31.9359C42.2621 30.1187 40.844 28.6218 39.053 28.5063ZM23.5016 35.6176H22.1938C20.9911 35.6176 20.0142 34.6408 20.0142 33.438V31.9359C20.0142 30.7332 20.9911 29.7563 22.1938 29.7563H23.5016V35.6176ZM32.0887 42.7395H30.5079C29.9827 42.7395 29.5572 42.3141 29.5572 41.7889C29.5572 41.2637 29.9827 40.8382 30.5079 40.8382H32.0887C32.614 40.8382 33.0394 41.2637 33.0394 41.7889C33.0394 42.3141 32.614 42.7395 32.0887 42.7395ZM41.0016 33.438C41.0016 34.6408 40.0247 35.6176 38.8219 35.6176H37.5142V29.7563H38.8219C40.0247 29.7563 41.0016 30.7332 41.0016 31.9359V33.438Z",
    fill: "#CE7ABF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_2100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(18 19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF4);
export default __webpack_public_path__ + "static/media/f4.7bc7657f7c8c1e046606f99ed234807b.svg";
export { ForwardRef as ReactComponent };